export default {
  tabDisable: '二維碼禁用',
  tabPageConfig: '禁用頁面配置',
  addDisable: '添加禁用',
  batchNo: '碼批次',
  batchNoPlaceholder: '請選擇二維碼批次',
  qrcode: '二維碼',
  qrcodePlaceholder: '請輸入二維碼',
  disableTime: '禁用時間',
  startTime: '開始時間',
  endTime: '結束時間',
  to: '至',
  colBatchSn: '碼批次',
  colQrcodeRange: '二維碼區間',
  colQrcodeCount: '二維碼數量',
  colForbidMessage: '禁用原因',
  colCreatedAt: '禁用時間',
  colAction: '操作',
  releaseDisable: '解除禁用',
  edit: '編輯',
  confirmReleaseTitle: '確認解除禁用',
  confirmReleaseContent: '確定要解除該碼的禁用狀態嗎？',
  addDisableTitle: '添加禁用',
  editDisableTitle: '編輯禁用',
  batchNoRequired: '請選擇碼批次',
  disableScope: '禁用範圍',
  disableScopeAll: '整批禁用',
  disableScopePartial: '部分禁用',
  disableReason: '禁用原因',
  disableReasonPlaceholder: '請輸入禁用提示語',
  disableReasonRequired: '請輸入禁用提示語',
  remark: '備註',
  remarkPlaceholder: '請輸入備註',
  multilingualHint: '多語言提示',
  localeAlreadyExists: '該語言版本已存在',
  atLeastOneReason: '至少保留一種語言版本的提示語',
  emptyText: '暫無禁用記錄',
  pageTitle: '頁面標題',
  pageTitleRequired: '請至少輸入一種語言的頁面標題',
  tipImage: '提示圖片',
  textColor: '文字顏色',
  bgColor: '頁面背景顏色',
  resetDefaultImage: '恢復默認圖',
  resetDefaultColor: '恢復默認顏色',
  defaultPreviewTitle: '二維碼異常',
  defaultTipImage: '禁用圖片',
  defaultTipText: '禁用提示語禁用提示語禁用提示語',
  batchCode: '碼批次',
  batchCodePlaceholder: '請輸入碼批次',
  batchCodeRequired: '請選擇碼批次',
  batchSn: '碼批次',
  batchSnPlaceholder: '請選擇二維碼批次',
  forbidType: '禁用類型',
  forbidTypeAll: '整批禁用',
  forbidTypePartial: '部分禁用',
  startCode: '起始碼',
  startCodePlaceholder: '請輸入起始碼',
  startCodeRequired: '請輸入起始碼',
  endCode: '結束碼',
  endCodePlaceholder: '請輸入結束碼',
  endCodeRequired: '請輸入結束碼',
  smallSerialStart: '小序號起',
  smallSerialStartPlaceholder: '請輸入小序號起始值',
  smallSerialEnd: '小序號止',
  smallSerialEndPlaceholder: '請輸入小序號結束值',
  forbidMessage: '禁用提示',
  forbidMessagePlaceholder: '請輸入禁用提示語',
  forbidMessageRequired: '請輸入禁用提示',
};
